<template>
	<div class="m-votes-news" v-if="show">
		<h4 class="m-bt">
			<span class="u-tt">用户调查</span>
		</h4>
		<div class="survey_block" v-for="(item, index) of votesList" :key="item.id" >
			<div class="surveyItem_wrap"> 
				<h4 class="survey_title">{{item.title}}</h4> 
				<ul class="items items_result" >
				    <li v-for="(key,value) of item.options" :key="key.id" > 
				  		<h5>{{value+1}}.{{key.title}}</h5> 
				 		<div class="proportion" v-if="isShowResult"> 
						 	 <span class="bar" :style="{width:(key.preo_val)+'%'}"></span>
						 	 <span class="preo_val">{{key.preo_val}}%</span> 
						</div> 
					</li>
				</ul> 
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['list'],
	computed: {
		show() {
			if(Jt.array.isEmpty(this.list)) {
				return false;
			}
			return true;
		},
		isShowResult(){
			const votesList = this.list || [];
			for (let i=0 ; i < votesList.length; i++){
				if(votesList[i].isShowResult){
					return true
				}
				return false
			}
		},
		votesList() {
			const votesList = this.list || [];
			for (let i=0 ; i < votesList.length; i++){
				let options = votesList[i].options, total = 0, len = options.length;
				for( let j = 0; j < len; j++){
					total+=parseInt(options[j].hits);
				}
				let preoArr = [];
				for(let k = 0;k < len; k++){
					let preo_val = 0;
					if(total >0 ){
						if(k !=len -1){
							preo_val=parseInt((parseFloat(options[k].hits)/total)*100);
						}else{
							let temp = 0;
							for (let k = 0;k < preoArr.length; k++){
								temp+=preoArr[k];
							}
							preo_val=100-temp;
						}
						preoArr.push(preo_val);
					}
					options[k].preo_val=preo_val;
				}
			}
			return votesList;
		}
	}

}
</script>


// WEBPACK FOOTER //
// news-votes.vue?6d44251a